import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiUploadService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** uploads ***/

  uploadPDF(file: any): Promise<string> {
    const url = `${this.apiUrl}uploads/savefile/doc`;
    return firstValueFrom(this.http.post<string>(url, file))
  }
  uploadPdfMatricula(file: any): Promise<string> {
    const url = `${this.apiUrl}uploads/savefile/matricula`;
    return firstValueFrom(this.http.post<string>(url, file))
  }
  uploadPdfInfo(file: any): Promise<string> {
    const url = `${this.apiUrl}uploads/savefile/info`;
    return firstValueFrom(this.http.post<string>(url, file))
  }
  uploadFileImage(file: FormData): Promise<string> {
    const url = `${this.apiUrl}uploads/savefile/image`;
    return firstValueFrom(this.http.post<string>(url, file))
  }
  uploadImageAvatar(file: FormData): Promise<string> {
    const url = `${this.apiUrl}uploads/savefile/avatar`;
    return firstValueFrom(this.http.post<string>(url, file))
  }
  deleteObjet(data: string): Promise<void> {
    const url = `${this.apiUrl}uploads/delete`;
    return firstValueFrom(this.http.post<void>(url, {url: data}))
  }
  deleteObjets(data: string[]): Promise<void> {
    const url = `${this.apiUrl}uploads/deleteobjects`;
    return firstValueFrom(this.http.post<void>(url, {urls: data}))
  }

}
